import './NavBar.css';
import { useState } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Branding from '../../ui/branding/Branding';
import ConfirmationDialog from '../../dialogs/ConfirmationDialog/ConfirmationDialog';
import { faCircleArrowLeft, faPowerOff } from '@fortawesome/free-solid-svg-icons'
export default function NavBar({pageIndex, pages, pageChangeCallback, setUserCallback}){
    const [navOpen, setNavOpen] = useState(localStorage.getItem("menu-open") === "true" ? true : false);
    const [logout, setLogout] = useState(false);
    const navOpenToggle = () =>{
      localStorage.setItem("menu-open", !navOpen)
      setNavOpen(!navOpen);
    } 
    return (
      <>
        <div className={"nav-bar" + (!navOpen ? " closed" : "")}>
          <Branding size={"medium"} color={"white"} logoOnly={!navOpen} />
          {   
            pages.map(page =>{
              return <button className={(pageIndex === page.index ? "selected" : "") + " nav-bar-button"} key={page.index} 
              onClick={() => pageChangeCallback(page.index)}>{page.icon? <FontAwesomeIcon icon={page.icon} 
              /> : ''} {page.text}</button>
            })
          }
          <button className={"nav-bar-toggle " + (!navOpen ? "closed" : "")}onClick={navOpenToggle}><FontAwesomeIcon icon={faCircleArrowLeft} /></button>
          <button className="nav-bar-button logout" onClick={() => {setLogout(true)}}><FontAwesomeIcon icon={faPowerOff} /> Log Out</button>
        </div>

        {
            <ConfirmationDialog show={logout} title="Log Out?" text="Are you sure you want to log out of PostShip?" 
                yesClickedCallback={() => setUserCallback(null)}
                noClickedCallback={()=> setLogout(false)}/>
        }
      </>
    )
}